import { DependencyProps } from './Dependency.typed';
import * as Styled from './Dependency.styled';

// TODO: Think about how to improve accessibility
// TODO: Use animation/transition library for show and hide animations
export const Dependency = (props: DependencyProps) => {
  const { isOpen, children, className } = props;
  if (!isOpen) {
    return null;
  }
  return (
    <Styled.Dependence className={className}>
      <Styled.Inner>{children}</Styled.Inner>
    </Styled.Dependence>
  );
};

export default Dependency;
